import {arrayUnion} from 'vuex-easy-firestore'

const stringSeperator = "|"
export default {
    computed: {},

    methods: {
        joinReasonsToString(downtime) {
            if (downtime.reason) {
                return downtime.reason.join(stringSeperator)
            } else {
                return downtime.join(stringSeperator)
            }
        },
        splitReasonsToString(downtime) {
            if (downtime.reason) {
                return downtime.reason.split(stringSeperator)
            } else {
                if (downtime.length) {
                    return downtime.split(stringSeperator)
                } else {
                    return ''
                }
            }
        }
    }

}